module.exports = __webpack_public_path__ + "static/media/dogs.bb9a4694.gif";